import React, {Component} from 'react';
import FusionCharts from 'fusioncharts/core';
/* Fusioncharts Component */
import Treemap from 'fusioncharts/viz/treemap';
import Bar2D from 'fusioncharts/viz/bar2d';
import ReactFC from 'react-fusioncharts';
/* Utils */
import { chartConfigGenerator, volumnShipmentCount, avgBillForCutomer, CustomerTabLoader} from '../util/index';

ReactFC.fcRoot(FusionCharts, Treemap, Bar2D);
export default class ChartContainerThird extends Component {
    render () {
      let {data, timeSelectorValue} = this.props;
      return (
        <div className="row  m-auto jutify-content-center chart-container">
            <div className="col-12 col-lg-6 chart-wrapper">
              <div className="chart-header kpi-header"> Volume of Shipment Orders by Customers </div>
              <div className="third-chart"  id="chart-container5">{(data.length) ? <ReactFC {...chartConfigGenerator({type: 'treemap', dataSource: volumnShipmentCount, data: data, timeSelectorValue: timeSelectorValue })} /> : <CustomerTabLoader/>}</div>
            </div>
            <div className="col-12 col-lg-6 chart-wrapper">
              <div className="chart-header kpi-header"> Average Bill Amount of Important Customers </div>
              <div className="third-chart" id="chart-container6">{(data.length) ? <ReactFC {...chartConfigGenerator({type: 'bar2d', dataSource: avgBillForCutomer, data: data, timeSelectorValue: timeSelectorValue })} /> : <CustomerTabLoader/>}</div>
            </div>
        </div>
      );
    }
    
}


// WEBPACK FOOTER //
// ./src/components/CustomerTab.js